import React from 'react';
import useLanguage from '../hooks/useLanguage';

const lang = useLanguage();
const LanguageContext = React.createContext(lang);

export default LanguageContext;

